import * as React from 'react';
import Dialog from '@mui/material/Dialog';


type Dialogprops = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export default function ScrollDialog({
  children,
  open = false,
  
}: Partial<Dialogprops>) {
  // Handle the dialog close action
  const handleClose = () => {
    
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        scroll="body" // Ensures content scrolls within the body
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        maxWidth={false} // Ensures dialog width is based on content
        fullWidth={true} // Ensures dialog takes full width of the screen
      >
       {children}
      </Dialog>
    </React.Fragment>
  );
}
